import { AgGridReact } from '@ag-grid-community/react'
import GridActions from '@components/Base/GridActions/actions'
import { IReportDTO } from '@interfaces/report.interface'
import { Box, Typography } from '@mui/material'
import React from 'react'
export type IRVHeader = {
  reportData: IReportDTO
  gridReference: AgGridReact
}
const GFRHeader: React.FC<IRVHeader> = ({ reportData, gridReference }) => (
  <Box display='grid' gridTemplateColumns='1fr auto' pb='8px'>
    <Box display='flex' gap={1}>
      <Typography fontWeight={600}>Portfolio:</Typography>
      <Typography fontWeight={600}>{reportData.portfolioName}</Typography>
    </Box>
    <GridActions gridApiRef={gridReference} />
  </Box>
)

export default GFRHeader
